import React, { useContext, useEffect, useState } from "react";
// import back from '../../assests/arrowleft.svg'
import next from "../../assests/arrow3Black.svg";
import closebutton from "../../assests/closebutton.svg";
import backButtonArrow from "../../assests/backButtonArrow.svg";
import { useNavigate } from "react-router";
import axios from "axios";
import { useUserAuth } from "../../context/UserAuthContext";
import Context from "../../context/Context";
import { createSearchParams } from "react-router-dom";
import { isEmpty } from "lodash";
import whatsAppIcon from "../../assests/whatsappLike.svg";
import VoucherPaymentPopup from "../VoucherPaymentPopup/VoucherPaymentPopup";

const VoucherValidation = ({
  setshowVoucher,
  singleFileDetails,
  setMultipleEntryPopup,
}) => {
  const [voucherError, setVoucherError] = useState(false);
  const { currentUser, searchParams } = useUserAuth();
  const [voucherPopup, setVoucherPayment] = useState(false);
  const voucher = searchParams?.get("vc");
  const [voucherCode, setPin] = useState(voucher || "");
  const {
    userIdToken,
    setPinData,
    details,
    setValidationComplete,
    organizerName,
  } = useContext(Context);
  const [pinValidationLoading, setPinValidationLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [voucherPurchase, setVoucherPurchase] = useState(false);
  const [voucherValues, setVoucherValues] = useState({
    email: currentUser?.email,
  });
  const [voucherValueError, setVoucherValueError] = useState({});

  const token = userIdToken || currentUser?.accessToken;
  const campaignId = window.location.pathname
    .split("/")[2]
    ?.replace(/\.html$/, "");
  const contestId = window.location.pathname
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const navigate = useNavigate();
  const privateType = singleFileDetails?.privateType;
  const orgId = singleFileDetails?.orgId;
  const cmpId = singleFileDetails?.campaignId;
  const ctstId = singleFileDetails?.contestId;
  const formatString = (value) => {
    let temp = value;
    temp = temp.replace(/\s+/g, "");
    setPin(temp);
  };
  useEffect(() => {
    if (voucher) {
      setVoucherPayment(true);
    }
  }, []);
  const verifyVoucher = async () => {
    if (privateType === "PIN") {
      if (voucherCode.length == 0) {
        setErrorMessage("Enter your pin");
        return;
      }
    } else {
      if (voucherCode.length == 0) {
        setErrorMessage("Enter voucher Code");
        return;
      }
      if (voucherCode.length < 7) {
        setErrorMessage("Invalid voucher code");
        return;
      }
    }
    // code to verify voucher here
    setErrorMessage("");
    try {
      setPinValidationLoading(true);
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_VALIDATE_UPLOAD}/${orgId}/${cmpId}/${ctstId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: { voucherCode },
      };
      const response = await axios(config);

      if (response.data.data.multipleEntriesFound) {
        setshowVoucher(false);
        setMultipleEntryPopup(true);
      } else {
        if (response.data.data.validationCompleted) {
          setPinData(response);
          setPinValidationLoading(false);
          setValidationComplete(true);
          const updatedParams = new URLSearchParams(searchParams); // Clone the current params
          if (privateType === "VOUCHER") {
            // Modify the 'vc' param
            updatedParams.set("vc", voucherCode);
          }
          navigate({
            pathname: `/${organizerName}/${campaignId}/${contestId}/participate`,
            search: `${updatedParams ? createSearchParams(updatedParams) : ""}`,
          });
        } else if (!response.data.data.isVoucherValid) {
          const responseData = response?.data?.data;
          let errorText = response?.data?.msg;
          if (responseData?.isVoucherValid == false) {
            if (responseData?.voucherStatus == "EXPIRED") {
              errorText =
                "You've already used this registration code to participate. Please purchase a new one or delete your current participation to proceed.";
            } else if (responseData?.voucherStatus == "PENDING") {
              errorText =
                "Your payment details couldn’t be updated with this registration code. Please try again later or use a new registration code or contact support for assistance.";
            } else {
              errorText =
                "It looks like the registration code isn't valid. Please verify and give it another try!";
            }
          }
          setVoucherError(errorText);
          setPinValidationLoading(false);
        }
      }
      setVoucherPayment(false);
    } catch (error) {
      setPinValidationLoading(false);
      setVoucherError(true);
      setVoucherPayment(false);
    }
  };
  const handleVoucherValuesChange = (e) => {
    const { id, value } = e.target;
    setVoucherValues((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleWhatappStausChange = () => {
    setVoucherValues((prevState) => ({
      ...prevState,
      whatsApp: !prevState?.whatsApp,
    }));
  };
  const validateEmail = (emailAdress) => {
    // eslint-disable-next-line no-useless-escape
    let regexEmail =
      // eslint-disable-next-line no-useless-escape
      /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    if (emailAdress.match(regexEmail)) {
      return true;
    } else {
      return false;
    }
  };
  const handlePurchase = () => {
    let errors = {};
    if (!validateEmail(voucherValues.email)) {
      errors.email = "Please enter a valid Email";
    }
    if (voucherValues?.whatsApp && !voucherValues?.whatsAppNumber) {
      errors.whatsAppNumber = "Please Whatsapp number";
    }
    if (!isEmpty(errors)) {
      setVoucherValueError(errors);
      return;
    } else {
      purchaseVoucher();
    }
  };

  const purchaseVoucher = async () => {
    setPinValidationLoading(true);
    try {
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_PURCHASE_VOUCHER}/${orgId}/${cmpId}/${ctstId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: voucherValues,
      };

      const response = await axios(config);
      if (response?.data?.status == "success") {
        let paymentRedirectUrl = response?.data?.paymentRedirectUrl;
        let url =
          response?.data?.paymentPayload?.data?.instrumentResponse?.redirectInfo
            ?.url;
        handleRedirectToLink(url, paymentRedirectUrl);
      }
      if (response?.data?.status == "fail") {
        setVoucherError(response?.data?.msg);
        setPinValidationLoading(false);
      }

      return response;
    } catch (error) {
      console.log(error.message);
      setPinValidationLoading(false);
    }
  };

  function handleRedirectToLink(link, paymentRedirectUrl) {
    const form = document.createElement("form");
    form.method = "get";
    form.action =
      paymentRedirectUrl || "https://www.shootmates.com/thirdpartyPayment";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "gatewayresp";
    input.id = "gatewayresp";
    input.value = link;
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
  }
  return (
    <div className="py-[29px] px-[20px] max-w-[425px] mx-auto">
      {!voucherError && (
        <>
          {voucherPurchase ? (
            <>
              <div className=" ">
                <button
                  className="contest-terms-button flex items-center justify-center "
                  onClick={() => setVoucherPurchase(false)}
                >
                  <img src={backButtonArrow} alt="" className="" />
                </button>
              </div>

              {/* Instructions */}
              <div className="flex flex-col mt-[40px] text-center">
                <span className="text-[21px] font-semibold">
                  Fill the form below to continue
                </span>
                <p className="text-small text-[#787878] text-center w-[90%] mx-auto mt-[11px]">
                  Enter your details in the form below to purchase registration
                  code.
                </p>
              </div>
              <div>
                <div className="w-full mt-[60px] flex flex-col items-center">
                  <label
                    htmlFor="email"
                    className="text-[#CDCDCD] text-small text-left w-full"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    required
                    onChange={handleVoucherValuesChange}
                    value={voucherValues?.email}
                    className="w-[100%] h-[60px] rounded-[8px]  bg-[#1C1C1C] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] mt-[10px] border-[1px] border-[#fff]"
                  />
                </div>
                {voucherValueError?.email && (
                  <p className="text-[#8B0000] text-small mt-[8px]">
                    {voucherValueError?.email}
                  </p>
                )}
              </div>
              <div>
                <div className="w-full mt-[30px] flex flex-col items-center">
                  <label
                    htmlFor="whatsAppNumber"
                    className="text-[#CDCDCD] text-small text-left w-full"
                  >
                    Phone Number
                  </label>
                  <input
                    type="text"
                    id="whatsAppNumber"
                    name="whatsAppNumber"
                    value={voucherValues?.whatsAppNumber}
                    onChange={handleVoucherValuesChange}
                    className="w-[100%] h-[60px] rounded-[8px]  bg-[#1C1C1C] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] mt-[10px] border-[1px] border-[#fff]"
                  />
                </div>
                {voucherValueError?.whatsAppNumber && (
                  <p className="text-[#8B0000] text-small mt-[8px]">
                    {voucherValueError?.whatsAppNumber}
                  </p>
                )}
              </div>
              <div className="flex items-start justify-start gap-[15px] mt-[30px]">
                <input
                  type="checkbox"
                  name="whatsApp"
                  id="whatsApp"
                  onChange={handleWhatappStausChange}
                  checked={voucherValues?.whatsApp}
                  className="w-[24px] h-[24px] accent-[#00a989]"
                />
                <label htmlFor="whatsApp" className="text-small text-left">
                  I would like to receive registration code in the above{" "}
                  <img
                    src={whatsAppIcon}
                    className="w-[15px] h-[15px] inline"
                  />{" "}
                  WhatsApp number
                </label>
              </div>
              {/* next button */}
              <div className="w-[100%]  flex justify-end">
                <button
                  style={{ backgroundColor: singleFileDetails?.buttonColor }}
                  className="commonButton w-full mt-[18px] flex items-center justify-center cursor-pointer text-regular-medium bg-[#EB0256]"
                  onClick={handlePurchase}
                  disabled={pinValidationLoading}
                >
                  {pinValidationLoading
                    ? "Submittting"
                    : `Pay ₹${singleFileDetails?.PD?.entryFee}`}
                  {/* <img src={next} alt="" className="ml-[10px]" /> */}
                </button>
              </div>
            </>
          ) : (
            <>
              {voucherPopup && (
                <VoucherPaymentPopup
                  setPopup={setVoucherPayment}
                  handleNext={verifyVoucher}
                  buttonColor={singleFileDetails?.buttonColor}
                  loading={pinValidationLoading}
                />
              )}
              <div className=" ">
                <button
                  className="contest-terms-button flex items-center justify-center "
                  onClick={() => setshowVoucher(false)}
                >
                  <img src={backButtonArrow} alt="" className="" />
                </button>
              </div>

              {/* Instructions */}
              <div className="flex flex-col mt-[40px] text-center">
                <span className="text-[21px] font-semibold">
                  {privateType == "PIN"
                    ? "Enter contest PIN to continue"
                    : "Enter your contest registration code to participate"}
                </span>
                {privateType == "PIN" && (
                  <p className="text-small text-[#787878] text-center w-[90%] mx-auto mt-[11px]">
                    This contest requires a PIN to participate and is not open
                    to everyone.
                  </p>
                )}
                {privateType == "VOUCHER" && (
                  <p className="text-small text-[#787878] text-center w-[90%] mx-auto mt-[11px]">
                    This contest involves a payment of ₹
                    {singleFileDetails?.PD?.entryFee}. You can purchase a
                    registration code from the options below.
                  </p>
                )}
                {/* <span className='text-[px] text-[#BDBDBD]'>{singleFileDetails?.entryFee.description}</span>
            <span className='text-[px] text-[#5073EF] font-semibold'>{singleFileDetails?.entryFee.linkText}</span> */}

                {/* <span className='text-[17px] font-semibold text-[#5073EF]'>Pay 1000.00 per participation </span> */}
              </div>
              {/* Voucher verification */}
              <div className="w-full mt-[60px] flex flex-col items-center">
                <label
                  htmlFor="voucher"
                  className="text-[#CDCDCD] text-small text-center w-fit mx-auto"
                >
                  {privateType == "PIN"
                    ? "Enter enter your pin"
                    : "Enter your registration code"}{" "}
                </label>
                <input
                  type="text"
                  id="voucher"
                  name="voucher"
                  required
                  value={voucherCode}
                  onChange={(e) => formatString(e.target.value)}
                  className="w-[100%] h-[60px] rounded-[8px]  bg-[#1C1C1C] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] mt-[10px] border-[1px] border-[#fff]"
                ></input>
              </div>
              {errorMessage && (
                <p className="text-[#8B0000] text-small mt-[8px]">
                  {errorMessage}
                </p>
              )}
              {/* next button */}
              <div className="w-[100%]  flex justify-end">
                <button
                  style={{ backgroundColor: singleFileDetails?.buttonColor }}
                  className="commonButton w-full mt-[18px] flex items-center justify-center cursor-pointer text-regular-medium bg-[#EB0256]"
                  onClick={verifyVoucher}
                  disabled={pinValidationLoading}
                >
                  {pinValidationLoading ? "Validating" : "Next"}
                  {/* <img src={next} alt="" className="ml-[10px]" /> */}
                </button>
              </div>
              {privateType == "VOUCHER" && (
                <p
                  className="text-left mb-[10px] text-base text-center cursor-pointer text-[#F6F5F5] mt-[20px]"
                  onClick={() => {
                    setVoucherPurchase(true);
                  }}
                >
                  Don't have registration code?{" "}
                  <span className="ml-[5px] text-base underline text-[#d99d04]">
                    Register Now
                  </span>
                </p>
              )}
            </>
          )}
        </>
      )}

      {voucherError && (
        <>
          <div className="">
            <button
              className="contest-terms-button flex items-center justify-center "
              onClick={() => setVoucherError(false)}
            >
              <img src={backButtonArrow} alt="" className="" />
            </button>
          </div>
          {/* Message */}
          <div className="flex flex-col items-center justify-center text-center mx-[34px] mt-[10px] h-[75%]">
            <span className="text-[21px] font-semibold mt-[10px]">
              {privateType == "PIN" && "Invalid pin"}
              {voucherError && (
                <div className="h-[60vh] flex flex-col items-center justify-center">
                  <span className="text-[21px] font-semibold">
                    Something went Wrong
                  </span>
                  <p className="text-small text-[#787878] text-center w-[90%] mx-auto mt-[11px]">
                    {voucherError}
                  </p>
                </div>
              )}
            </span>
            {/* <span className='text-[px] text-[#BDBDBD]'>{singleFileDetails?.entryFee.description}</span> */}
            <span
              style={{ color: singleFileDetails?.buttonColor }}
              className="text-[#5073EF] font-semibold cursor-pointer"
              onClick={() => {
                navigate("/payment");
              }}
            >
              {singleFileDetails?.entryFee?.linkText}
            </span>
            {/* <span className='text-[17px] text-[#5073EF] font-semibold'>Pay 1000.00 per participation </span> */}
          </div>
        </>
      )}
    </div>
  );
};

export default VoucherValidation;
